import { ENotificationType } from "../interfaces";
import { useWatchBaseNotification, type IUseWatchBaseNotificationProps } from "./useWatchBaseNotification";

export type InvoiceNotificationPayload = {
  uid?: string;
  /** Legacy key used by older emitters; kept for backwards compatibility. */
  id?: string;
  identifierId?: string;
};

export const useWatchInvoiceNotifications = ({
  dissableSnackbarAlert = false,
  onNotificationArrived,
  }: Omit<IUseWatchBaseNotificationProps<InvoiceNotificationPayload>, "notificationTypes" | "buildSnackbarMessage"> = {}) =>
  useWatchBaseNotification<InvoiceNotificationPayload>({
    notificationTypes: [ENotificationType.InvoicePaid, ENotificationType.InvoicePaidDeposit],
    dissableSnackbarAlert,
    onNotificationArrived,
    buildSnackbarMessage: (msg) => {
      return msg?.message;
    },
  });
